import React from 'react';
import Nooky from '../components/Nooky'; // adjust path as necessary

const NookyPresentation = () => {
  return (
    <>
      <Nooky />
    </>
  );
};

export default NookyPresentation;
